"use client";
import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { InkeepEmbeddedChatProvider as u, InkeepEmbeddedChatImplContent as I } from "./embedded-chat.js";
import { Shadow as f, RootProvider as b, WebWidgetInteractionType as C, useModal as g, WidgetProvider as w } from "@inkeep/cxkit-styled";
import { InkeepEmbeddedSearchProvider as A, InkeepEmbeddedSearchImplContent as k } from "./embedded-search.js";
import { useWidgetImpl as S } from "./embedded-search-and-chat.impl.js";
import { Fragment as E } from "react";
import { ModalContent as P } from "./modal.js";
function L(t) {
  const { config: o, ...d } = S(t);
  return /* @__PURE__ */ e(
    f,
    {
      wrapperStyles: {
        height: "inherit",
        width: "inherit"
      },
      children: /* @__PURE__ */ e(b, { config: o, componentType: C.EmbeddedSearchAndChat, children: /* @__PURE__ */ e(v, { ...d }) })
    }
  );
}
function v(t) {
  const {
    view: o,
    setView: d,
    shouldShowAskAICard: s,
    onToggleView: r,
    defaultView: n,
    shouldAutoFocusInput: i,
    searchLabel: h,
    askAILabel: c
  } = t, m = g() ? P : E, a = {
    isHidden: o === "chat",
    onToggleView: r,
    shouldShowAskAICard: s,
    shouldAutoFocusInput: i && n === "search",
    searchLabel: h,
    askAILabel: c
  }, p = {
    isHidden: o === "search",
    onToggleView: r,
    shouldAutoFocusInput: i && n === "chat",
    searchLabel: h,
    askAILabel: c
  };
  return /* @__PURE__ */ e(w, { widget: { setView: d }, children: /* @__PURE__ */ e(A, { ...a, children: /* @__PURE__ */ e(u, { ...p, children: /* @__PURE__ */ l(m, { children: [
    /* @__PURE__ */ e(k, { ...a }),
    /* @__PURE__ */ e(I, { ...p })
  ] }) }) }) });
}
export {
  L as InkeepEmbeddedSearchAndChat,
  v as InkeepEmbeddedSearchAndChatImpl
};
